/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/19/20
 * Time: 3:14 PM
 */
import React from 'react';

const App = (props) => {
  return (
      <div className="position-relative">
          <section className="lecture-intro">
              <div className="separator separator-bottom separator-skew">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      preserveAspectRatio="none"
                      version="1.1"
                      viewBox="0 0 2560 100"
                      x="0"
                      y="0"
                  >
                      <polygon
                          className="fill-white"
                          points="2560 0 2560 100 0 100"
                      />
                  </svg>
              </div>
          </section>
      </div>
  )
};
export default App;
